import React from 'react';
import './HipaaNotice.scss';

const HipaaNotice: React.FC = () => {
  const lastUpdated = 'January 15, 2024';
  const effectiveDate = 'January 15, 2024';

  return (
    <div className="safety-compliance-container">
      <div className="content-wrapper">
        <div className="header-section">
          <h1>Safety & Compliance</h1>
          <p className="subtitle">Building Materials Safety and Regulatory Compliance</p>
          <p className="last-updated">Effective Date: {effectiveDate} | Last Updated: {lastUpdated}</p>
        </div>

        <div className="notice-content">
          <section className="notice-section">
            <h2>Your Safety. Our Commitment. Industry Standards.</h2>
            <p>This notice describes our commitment to safety standards, regulatory compliance, and best practices in the building materials industry. Please review it carefully.</p>
          </section>

          <section className="notice-section">
            <h2>Safety Standards</h2>
            <p>We are committed to maintaining the highest safety standards:</p>
            <ul>
              <li><strong>Product Safety</strong> - All products meet or exceed industry safety standards and regulatory requirements</li>
              <li><strong>Material Safety Data Sheets (MSDS)</strong> - Available for all chemical products and materials</li>
              <li><strong>Safety Equipment</strong> - Personal protective equipment available for purchase</li>
              <li><strong>Safety Training</strong> - Resources and guidance for safe product use</li>
              <li><strong>Quality Assurance</strong> - Regular testing and quality control procedures</li>
              <li><strong>Environmental Compliance</strong> - Products meet environmental regulations</li>
              <li><strong>Building Codes</strong> - Products comply with local and national building codes</li>
              <li><strong>Customer Support</strong> - Expert advice on safe product selection and use</li>
            </ul>
          </section>

          <section className="notice-section">
            <h2>Product Information & Warnings</h2>
            <p>Important safety information for our products:</p>
            <ul>
              <li><strong>Read all labels and instructions</strong> - Follow manufacturer guidelines for all products</li>
              <li><strong>Use appropriate safety equipment</strong> - Gloves, goggles, masks, and other PPE as recommended</li>
              <li><strong>Ventilation requirements</strong> - Ensure proper ventilation when using chemical products</li>
              <li><strong>Storage guidelines</strong> - Store products according to manufacturer recommendations</li>
              <li><strong>Disposal procedures</strong> - Follow proper disposal methods for all materials</li>
            </ul>
          </section>

          <section className="notice-section">
            <h2>Regulatory Compliance</h2>
            <p>We maintain compliance with applicable regulations:</p>
            
            <h3>Building Codes</h3>
            <p>All products meet or exceed local and national building code requirements.</p>
            <p><strong>Example:</strong> Lumber products meet grade standards for structural applications.</p>

            <h3>Environmental Regulations</h3>
            <p>Products comply with environmental protection standards and regulations.</p>
            <p><strong>Example:</strong> Paint products meet VOC (Volatile Organic Compound) limits.</p>

            <h3>Safety Standards</h3>
            <p>All products meet industry safety standards and testing requirements.</p>
            <p><strong>Example:</strong> Electrical products are UL listed or equivalent.</p>
          </section>

          <section className="notice-section">
            <h2>Quality Assurance</h2>
            <p>Our quality assurance program includes:</p>
            <ul>
              <li>Regular product testing and quality control</li>
              <li>Supplier verification and certification</li>
              <li>Product traceability and documentation</li>
              <li>Customer feedback and complaint resolution</li>
              <li>Continuous improvement processes</li>
            </ul>
          </section>

          <section className="notice-section">
            <h2>Customer Responsibilities</h2>
            <p>When using our products, customers should:</p>
            <ul>
              <li>Read and follow all product instructions and safety warnings</li>
              <li>Use appropriate personal protective equipment</li>
              <li>Ensure proper installation and application</li>
              <li>Follow local building codes and regulations</li>
              <li>Dispose of materials properly and safely</li>
              <li>Contact us with any questions about product safety</li>
            </ul>
          </section>

          <section className="notice-section">
            <h2>Product Recalls and Safety Alerts</h2>
            <p>We maintain procedures for handling product recalls and safety alerts:</p>
            <ul>
              <li>Immediate notification of affected customers</li>
              <li>Product removal from inventory when necessary</li>
              <li>Replacement or refund options for affected products</li>
              <li>Coordination with manufacturers and regulatory agencies</li>
            </ul>
          </section>

          <section className="notice-section">
            <h2>Training and Resources</h2>
            <p>We provide various resources to help ensure safe product use:</p>
            <ul>
              <li>Product safety data sheets and technical information</li>
              <li>Installation and application guides</li>
              <li>Safety training materials and videos</li>
              <li>Expert consultation and technical support</li>
              <li>Workshop and demonstration events</li>
            </ul>
          </section>

          <section className="notice-section">
            <h2>Environmental Responsibility</h2>
            <p>Our environmental commitment includes:</p>
            <ul>
              <li>Offering eco-friendly and sustainable product options</li>
              <li>Proper handling and disposal of hazardous materials</li>
              <li>Recycling programs for certain materials</li>
              <li>Energy-efficient product recommendations</li>
              <li>Compliance with environmental regulations</li>
            </ul>
          </section>

          <section className="notice-section">
            <h2>Changes to Safety and Compliance Information</h2>
            <p>We may update safety and compliance information as regulations change or new information becomes available. Updated information will be posted on our website and available upon request.</p>
          </section>

          <section className="notice-section">
            <h2>Contact Information</h2>
            <p>If you have any questions about our safety and compliance policies, please contact us:</p>
            <div className="contact-info">
              <p><strong>Florida First Psychiatry</strong></p>
              <p>1820 Miccosukee Commons Drive<br />Tallahassee, FL 32308</p>
              <p>Phone: (850) 765-8120</p>
              <p>Email: info@ffps.pro</p>
            </div>
          </section>

          <section className="notice-section">
            <h2>Reporting Safety Concerns</h2>
            <p>If you have safety concerns about any of our products, please contact us immediately using the information above. We take all safety concerns seriously and will investigate promptly.</p>
            <p>You can also report safety concerns to relevant regulatory agencies:</p>
            <ul>
              <li>Consumer Product Safety Commission (CPSC)</li>
              <li>Environmental Protection Agency (EPA)</li>
              <li>Occupational Safety and Health Administration (OSHA)</li>
              <li>Local building code enforcement agencies</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default HipaaNotice;

